import React, { useEffect, useRef, useState } from 'react';
import { DataGrid, DataGridColumn, FilterOperators, LogicTypes } from 'modules/shared/DataGrid';
import { Button, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import AddCircle from 'mdi-react/AddCircleIcon';
import Search from 'mdi-react/SearchIcon';
import { useDispatch, useSelector } from 'react-redux';
import { DefaultRecordType } from 'rc-table/lib/interface';
import HighlightOff from 'mdi-react/HighlightOffIcon';
import classes from '../../../security/containers/TripsTabContainer/TripsTab.module.scss';
import { useModal } from '../../../shared/hooks';
import { TransportEditModal } from './components/TransportEditModal';
import { clearError, getSMCCarsRequest } from './services/actions';
import { RootState } from '../../../../rootReducer';
import { DateCell } from './components/DateCell';
import { TransportAddModal } from './components/TransportAddModal';
import Loader from '../../../kiosk/components/Loader';
import ErrorMsg from '../../../shared/ErrorMsg';
import { defaultGridState } from '../../../security/containers/TripsTabContainer/constants';
import { Filter, GridFilter } from '../../../shared/DataGrid/utils/interfaces';
import { useGridState } from '../../../shared/DataGrid/hooks/useGridState';

export const fieldsNames = ['number'];
export const MIN_FILTER_VALUE_LENGTH = 1;

const SMCcars = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState<any>();
  const [filterInputValue, setFilterInputValue] = useState('');
  const filterInputRef = useRef<HTMLInputElement>(null);
  const { isShow, closeModal, openModal } = useModal();
  const { isShow: isShowAddModal, openModal: openAddModal, closeModal: closeAddModal } = useModal();

  const carsList = useSelector((state: RootState) => state.directorModuleReducer.smcCarsReducer.carsList);
  const loading = useSelector((state: RootState) => state.directorModuleReducer.smcCarsReducer.loading);
  const error = useSelector((state: RootState) => state.directorModuleReducer.smcCarsReducer.error);

  const gridState = useGridState(carsList, defaultGridState);

  useEffect(() => {
    dispatch(getSMCCarsRequest());
  }, []);

  const handleClearIconClick = () => {
    setFilterInputValue('');
    if (filterInputRef.current) {
      filterInputRef.current.focus();
    }
  };

  const createModal = (rowData: DefaultRecordType) => ({
    onDoubleClick: () => {
      setData(rowData);
      return openModal();
    },
  });

  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterInputValue(e.target.value);
  };

  useEffect(() => {
    if (filterInputValue.length < MIN_FILTER_VALUE_LENGTH) {
      gridState.setFilter({
        logic: LogicTypes.and,
        filters: [],
      });
    } else {
      const newFilter = {
        logic: LogicTypes.or,
        filters: fieldsNames.map(
          (name): Filter => ({
            operator: FilterOperators.contains,
            value: filterInputValue,
            field: name,
          }),
        ),
      } as GridFilter;
      gridState.setFilter(newFilter);
    }
  }, [filterInputValue]);

  return (
    <>
      {loading && <Loader />}
      <ErrorMsg isShow={!!error} error={error?.data?.Errors[0].Message} closeHandler={() => dispatch(clearError())} />
      <Container fluid className={classes.filterContainer}>
        <Row>
          <Col className="d-flex align-items-center">
            <Button variant="light" className={classes.add} onClick={() => openAddModal()}>
              <AddCircle className={classes.plusIcon} /> Додати
            </Button>
            <InputGroup className={classes.filter}>
              <Form.Control
                as="input"
                type="text"
                name="filter"
                onChange={handleFilterChange}
                value={filterInputValue}
                ref={filterInputRef}
              />
              <Search size={18} className={classes.searchIcon} />
              {!!filterInputValue && (
                <HighlightOff size={18} className={classes.clearFilterIcon} onClick={handleClearIconClick} />
              )}
            </InputGroup>
          </Col>
        </Row>
      </Container>
      <DataGrid
        pageable
        data={gridState.gridData}
        sort={gridState.sort}
        total={gridState.total}
        skip={gridState.pagination?.skip}
        pageSize={gridState.pagination?.pageSize}
        onPageChange={gridState.handlePageChange}
        onSortChange={gridState.handleSortChange}
        onRow={createModal}
      >
        <DataGridColumn title="Держномер" dataIndex="number" key="number" width="5%" />
        <DataGridColumn title="Тип або марка" dataIndex="description" key="description" width="5%" />
        <DataGridColumn
          title="Дата додавання у список"
          dataIndex="createDate"
          key="createDate"
          width="90%"
          render={DateCell}
        />
      </DataGrid>
      <TransportEditModal show={isShow} data={data} onClose={closeModal} />
      <TransportAddModal show={isShowAddModal} onClose={closeAddModal} />
    </>
  );
};

export default SMCcars;
